import NotificationBanner from "components/admin/StripeAccountNotificationBanner/NotificationBanner"
import useStripeInfo from "hooks/use_stripe_info"

const StripeAccountNotificationBanner = () => {
  const { enabled, notificationsEnabled } = useStripeInfo()
  return enabled && notificationsEnabled ? <NotificationBanner /> : null
}

export default StripeAccountNotificationBanner
